import React, { Component } from "react";
import { Form, Field, withFormik } from "formik";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";
import isEmpty from "lodash/isEmpty";

import i18n from "../../../../../translations/i18n";
import { SEARCH_PARAMS_SHAPE } from "../../../../../constants/searchConstants";
import InputField from "../../../../ui/form/input_field";


class SearchForm extends Component {

  constructor(props) {
    super(props);
  }

  debouncedSubmit = debounce(this.props.handleSubmit, 300);

  render () {
    const { handleSubmit } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        <div className="form__group header__search-form">
          <Field
            name="q"
            type="text"
            autoFocus={true}
            component={InputField}
            className="form__field header__search-field"
            placeholder={i18n.t('header.search.placeholder')}
            onChange={this.debouncedSubmit}
          />
        </div>
      </Form>
    );
  }
}


const SearchFormWithFormik = withFormik({
  enableReinitialize: true,
  mapPropsToValues: ({initialValues}) => initialValues,
  handleSubmit: (values, {props: {onSubmit}}) => onSubmit(values),
  validate: (values) => {
    let errors = {};

    if (isEmpty(values.q)) {
      errors.email = i18n.t("validation.field.required");
    }

    return errors;
  },
})(SearchForm);

SearchFormWithFormik.propTypes = {
  initialValues: PropTypes.shape(SEARCH_PARAMS_SHAPE).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default SearchFormWithFormik